<template>
  <div>

    <div class="login-head fc-bet container">
      <div class="fc">
        <a href="" class="logo fc" v-if="false">
          <img src="@/assets/logo.jpg" alt="" srcset="">
        </a>
        <div class="login-title">
          信息修改
        </div>
      </div>
    </div>
    <div class="register-container">
      <div class="personal-register" v-if="stepActive === 1" style="margin-top: 50px">
        <el-form ref="form" :model="form" :rules="rules" size="small" :inline="true" label-width="140px" class="form">
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>推荐码
            </div>
            <input type="text" class="input " placeholder="请输入推荐码" v-model="form.pid">
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>手机号
            </div>
            <input type="tel" class="input" placeholder="请输入手机号" v-model="form.contactsMobile">
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>联系人
            </div>
            <input type="text" class="input" placeholder="请输入联系人姓名" v-model="form.contacts">
            <div class="tip err">
            </div>
          </div>
          <!--          <div class="form-group">-->
          <!--            <div class="tips">-->
          <!--              <span class="require">*</span>验证码-->
          <!--            </div>-->
          <!--            <input type="text" class="input sms" placeholder="请输入验证码" v-model="form.code">-->
          <!--            <div class="btn-send-code" v-if="isSend==false">-->
          <!--              <ge-code :config="config"></ge-code>-->
          <!--            </div>-->
          <!--            <div class="btn-send-code" v-else>-->
          <!--              获取短信验证码-->
          <!--            </div>-->
          <!--            <div class="tip err">-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>登录密码
            </div>
            <input type="password" v-model="form.password" class="input" placeholder="请设置密码(6-18个字符)"
                   maxlength="11" v-if="pwd_hide">
            <input type="text" v-model="form.password" class="input" placeholder="请设置密码(6-18个字符)" maxlength="11"
                   v-else>
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>确认密码
            </div>
            <input type="password" v-model="form.password2" class="input" placeholder="请重复输入密码(6-18个字符)"
                   maxlength="11"
                   v-if="pwd_hide2">
            <input type="text" v-model="form.password2" class="input" placeholder="请重复输入密码(6-18个字符)"
                   maxlength="11"
                   v-else>
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>公司名称
            </div>
            <input type="text" class="input" placeholder="请输入公司名称" v-model="form.name">
            <div class="tip err">
            </div>
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>营业执照
            </div>
            <div class="upload">
              <el-upload
                  action="https://zxapi.tengen.com.cn/api/pc-shop/upload"
                  class="upload-demo"
                  :on-success="handleAvatarSuccess"
                  :show-file-list="false"
                  drag>
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-if="!imageUrl" class="el-icon-upload"></i>
                <div v-if="!imageUrl" class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div v-if="!imageUrl" class="el-upload__tip" slot="tip">支持png／jpg／jpeg图片格式（大小5M以内）</div>
              </el-upload>
            </div>
            <div class="tip err">
            </div>
          </div>
          <div class="form-group">
            <div class="tips">
              <span class="require">*</span>社会统一信用代码
            </div>
            <input type="text" class="input " placeholder="请输入社会统一信用代码"
                   v-model="form.unifiedSocialCreditCode">
          </div>
          <div class="form-group">
            <button type="button" class="btn" id="registerBtn" @click="register">确认修改</button>
          </div>
        </el-form>
      </div>
    </div>
    <i-footer></i-footer>
  </div>
</template>

<script>

import geCode from 'vue-gecode'
import {getToken} from "@/axios/cookies";
import {getDistributorInfo, getVerify, registerSubmit, registerSubmitUpdate} from "@/api/login";
import IFooter from "@/components/i-footer";

export default {
  components: {
    geCode
  },
  data() {
    return {
      headers: {
        Authorization: getToken()
      },
      dialogVisible: false,
      isSend: false,
      form: {
        pid: null,
        contacts: null,
        contactsMobile: null,
        code: null,
        password: null,
        password2: null,
        name: null,
        operationLicense: null,
        unifiedSocialCreditCode: null,

      },
      rules: {
        name: [
          {required: true, message: '经销商名称不能为空', trigger: 'blur'}
        ],
      },
      isReady: false,
      stepActive: 1,
      imageUrl: null,
      phone: null,
      recommendationCode: null,
      password: "",
      repassword: "",
      pwd_hide: true,
      pwd_hide2: true,
      // config: {
      //   //开始时候的文本
      //   startText: '获取短信验证码',
      //   //获取验证码结束后文本
      //   endText: '再次获取',
      //   //验证码倒计时总时间(秒)
      //   totalTime: 60,
      //   //验证码每次隔多久变一次(秒)
      //   tickTime: 1,
      //   //倒计时执行期添加的class 默认 isRun
      //   activeClass: 'isRun',
      //   //自定义倒计时期间文本的显示内容
      //   computeText(num) {
      //     //num 倒计时时间
      //     return '重新获取 ' + num + 's';
      //   },
      //   //是否可以发送
      //   canTodo: () => {
      //     //返回值判定是否可以发送
      //     // let result = /^1[3456789]\d{9}$/.test(Number(this.phone));
      //     // console.log('判断是否可以发送验证码', result);
      //     // if (!result) {
      //     //   alert('手机号格式不正确');
      //     // }
      //     if (this.form.contactsMobile) {
      //       return true
      //     } else {
      //       return false;
      //     }
      //   },
      //   //canTode验证成功后执行 发送短信验证码
      //   todo: () => {
      //     //这里写验证码的获取程序
      //     console.log('发送验证码')
      //     getVerify({
      //       phone: this.form.contactsMobile,
      //       type: 'register'
      //     }).then(res => {
      //       console.log('发送短信', res)
      //     })
      //     //同时手机号不可改变了
      //     this.readonly = true
      //   },
      //   //发送完成后的回调
      //   endCallback(type, config) {
      //     //type 回调产生原因  0: 时间结束   其他值由this.$refs.geCode.stop(1)调入自定义
      //     //config config配置
      //     console.log('发送完成后的回调', type, config);
      //     //同时手机号可改变了
      //     this.readonly = false
      //   },
      //   //每次点击都会被调用
      //   click(isRun) {
      //     //isRun 是否在运行中
      //     console.log(`当前验证码状态是:${isRun ? '发送中' : '可发送'}状态`)
      //   },
      //   //是否可用   默认ture
      //   canUse: true,
      //   //不可用时的类名  默认no-can
      //   noCanClass: 'no-can',
      // },
    }
  },
  mounted() {
    console.log('修改信息页面，', this.$route.query.id)
    if (this.$route.query.id) {
      this.getDistributorInfoFun(this.$route.query.id)
    }
  },
  watch: {
    "imageUrl": function (val) {
      console.log('上传后检测参数', this.imageUrl)
      this.form.operationLicense = this.imageUrl
    }
  },

  methods: {
    getDistributorInfoFun(id) {
      getDistributorInfo({distributorId: id}).then(res => {
        console.log('修改信息页面的用户信息', res.data)
        this.form.contacts = res.data.contacts
        this.form.contactsMobile = res.data.contactsMobile
        this.form.name = res.data.name
        this.form.unifiedSocialCreditCode = res.data.unifiedSocialCreditCode
        this.form.pid = res.data.pid
        // this.form.operationLicense =res.data.operationLicense
        this.imageUrl = res.data.operationLicense
        console.log('图片', this.imageUrl)
      })
    },

    isReadyFun() {
      console.log(this.isReady)
    },
    handleAvatarSuccess(res, file) {
      // this.operationLicenseUrl = res.link
      this.imageUrl = res.link
    },
    sendCode() {
      this.$refs.timerbtn.setDisabled(true); //设置按钮不可用

    },
    onPrev() {
      this.stepActive = 1
    },
    register() {
      if (!this.form.pid) {
        this.$message.error('推荐码不能为空');
        return
      }
      if (!this.form.contacts) {
        this.$message.error('联系人不能为空');
        return
      }
      if (!this.form.contactsMobile) {
        this.$message.error('手机号不能为空');
        return
      }
      if (!this.form.password) {
        this.$message.error('密码不能为空');
        return
      }
      if (!this.form.password2) {
        this.$message.error('重复密码不能为空');
        return
      }
      if (this.form.password != this.form.password2) {
        this.$message.error('俩次密码不一致！');
        return
      }
      if (!this.form.name) {
        this.$message.error('公司名称不能为空');
        return
      }
      if (!this.form.operationLicense) {
        this.$message.error('营业执照不能为空');
        return
      }
      if (!this.form.unifiedSocialCreditCode) {
        this.$message.error('社会统一信用代码不能为空');
        return
      }
      registerSubmitUpdate(this.form).then(res => {
        console.log('注册返回值', res)
        if (res.status == 200) {
          this.$message.success('修改成功')
          this.$router.push("/")
        } else {
          this.$message.error(res.msg);
        }
      })

    }
  },


}
</script>

<style lang="less" scoped>
@import '@/assets/reg.less';

.city-selects {
  width: 450px;
}

.city-select {
  width: 160px;

}

.city-select + .city-select {
  margin-left: 15px;
}

.btn-send-code {
  height: 50px;
  margin-left: 15px;
  line-height: 50px;

  span {
    height: 50px;
    line-height: 50px;
  }
}

.el-upload__tip {
  padding: 10px 0;
}


/*复选框换成图片*/
.checkboxStyle-small {
  display: inline-block;
  cursor: pointer;
}

.checkboxStyle-small input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  display: none;
}

.checkboxStyle-small input[type="checkbox"]:disabled + span {
  opacity: .4;
  position: relative;
  top: -1px;
}

.checkboxStyle-small input[type="checkbox"] + span {
  width: 13px;
  height: 13px;
  display: inline-block;
  position: relative;
  top: -1px;
  background: url('../assets/company-default.png') no-repeat -725px -10px;
  vertical-align: text-bottom;
}

.checkboxStyle-small input[type="checkbox"]:checked + span {
  background-position: -725px -24px;
}

.personal-register .btn {
  height: 50px;
  line-height: 50px;
  width: 40%;
  border-radius: 20px;
  font-size: 22px;
}

.personal-register .btn.default {
  background: #fff;
  color: @l;
  border: 1px solid @l;
  width: 25%;
}

.personal-register .btn + .btn {
  margin-left: 20px;
}

.personal-register3 {
  text-align: center;
  padding: 25px 0 20vh;
  font-size: 22px;

  a {
    color: @L;
    text-decoration: underline;
  }
}
</style>
<style lang="less">
.personal-register {


  .el-upload {
    display: block;
  }

  .el-upload-dragger {
    width: 450px;
    border-radius: 0;
  }

}

</style>
